import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SearchBox = _resolveComponent("SearchBox");
  const _component_WebsiteUpdatesBanner = _resolveComponent("WebsiteUpdatesBanner");
  const _component_CoveoAILoggedOut = _resolveComponent("CoveoAILoggedOut");
  const _component_Cart = _resolveComponent("Cart");
  return _openBlock(), _createElementBlock(_Fragment, null, [$options.hasSearchBox ? (_openBlock(), _createBlock(_Teleport, {
    key: 0,
    to: "#global-in-page-search-box"
  }, [_createVNode(_component_SearchBox, {
    displayCoveoIcon: false
  })])) : _createCommentVNode("", true), $options.hasSearchBoxWithCoveo ? (_openBlock(), _createBlock(_Teleport, {
    key: 1,
    to: "#global-in-page-search-box-with-coveo"
  }, [_createVNode(_component_SearchBox, {
    displayCoveoIcon: true
  })])) : _createCommentVNode("", true), (_openBlock(), _createBlock(_Teleport, {
    to: "#website-update-banner"
  }, [_ctx.isAuthenticated && _ctx.bannerVisible && !_ctx.languageDropdownVisible ? (_openBlock(), _createBlock(_component_WebsiteUpdatesBanner, {
    key: 0
  })) : _createCommentVNode("", true)])), $options.hasCoveoLoggedOutInfo ? (_openBlock(), _createBlock(_Teleport, {
    key: 2,
    to: "#coveo-logged-out-info"
  }, [_createVNode(_component_CoveoAILoggedOut)])) : _createCommentVNode("", true), $options.hasCartItems ? (_openBlock(), _createBlock(_Teleport, {
    key: 3,
    to: ".cart-wrapper"
  }, [_createElementVNode("div", {
    class: _normalizeClass(_ctx.isButtonHovered ? 'visible' : 'hidden')
  }, [_createVNode(_component_Cart)], 2)])) : _createCommentVNode("", true)], 64);
}